export const URL_MARKETING_ROUTE = 'marketing';
export const URL_SUFFIX_LIBRARY_MANAGED = 'productgroups';
